var _defs, _rect, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324 304",
    width: 324,
    height: 304,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tileShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "125%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 5,
    floodColor: "#000000",
    floodOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 300,
    height: 276,
    rx: 18,
    ry: 18,
    fill: "#FFFFFF",
    filter: "url(#tileShadow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(162 96) scale(1.7) translate(-82 -68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64 100 C 64 100, 72 108, 92 104 C 104 102, 116 88, 116 88 C 116 88, 108 84, 96 90 C 88 94, 80 94, 72 92 Z",
    fill: "#FFC1E3",
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 90 L 74 106 L 66 112 L 54 96 Z",
    fill: "#990033",
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 28,
    width: 52,
    height: 66,
    rx: 4,
    ry: 4,
    fill: "#FFFFFF",
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 42,
    x2: 108,
    y2: 42,
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 52,
    x2: 108,
    y2: 52,
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 62,
    x2: 100,
    y2: 62,
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 72,
    x2: 108,
    y2: 72,
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 42,
    r: 18,
    fill: "#D81B60",
    stroke: "#1A1A1A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 36,
    width: 18,
    height: 14,
    rx: 2,
    fill: "#E29253",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53 43 L 71 43",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 222,
    fontFamily: "'Source Sans Pro', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 600,
    fill: "#3A3A3A",
    textAnchor: "middle"
  }, "Test request forms")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrfLogo);
export default __webpack_public_path__ + "static/media/trf_logo.30bbd96734241a480cab91619cee3268.svg";
export { ForwardRef as ReactComponent };